import { useEffect, useRef } from "react";

export function useModalBackClose(isOpen, onClose) {
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!isOpen) return;

    window.history.pushState({ modalOpen: true }, "");
    pushedRef.current = true;

    const handlePopState = () => {
      pushedRef.current = false;
      onClose();
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);

      if (pushedRef.current && window.history.state?.modalOpen) {
        pushedRef.current = false;
        window.history.back();
      }
    };
  }, [isOpen]);
}
